import { 
  collection, 
  doc, 
  getDocs, 
  getDoc, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  query, 
  orderBy,
  serverTimestamp 
} from 'firebase/firestore';
import { db } from './firebase';

// Servicio de carpetas
export const foldersService = {
  // Obtener todas las carpetas
  getFolders: async () => {
    try {
      const q = query(
        collection(db, 'folders'),
        orderBy('name', 'asc')
      );
      
      const querySnapshot = await getDocs(q);
      const folders = [];
      
      querySnapshot.forEach((doc) => {
        folders.push({
          id: doc.id,
          ...doc.data()
        });
      });
      return folders;
    } catch (error) {
      console.error('❌ Error al obtener carpetas:', error);
      throw error;
    }
  },

  // Obtener una carpeta por ID
  getFolderById: async (folderId) => {
    try {
      const docRef = doc(db, 'folders', folderId);
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        return {
          id: docSnap.id,
          ...docSnap.data()
        };
      } else {
        throw new Error('Carpeta no encontrada');
      }
    } catch (error) {
      console.error('Error al obtener carpeta:', error);
      throw error;
    }
  },

  // Crear una nueva carpeta
  createFolder: async (folderData) => {
    try {
      const docRef = await addDoc(collection(db, 'folders'), {
        ...folderData,
        createdAt: serverTimestamp(),
        lastUpdated: serverTimestamp(),
        documentCount: 0
      });
      
      return {
        id: docRef.id,
        ...folderData
      };
    } catch (error) {
      console.error('Error al crear carpeta:', error);
      throw error;
    }
  },

  // Actualizar una carpeta
  updateFolder: async (folderId, folderData) => {
    try {
      const docRef = doc(db, 'folders', folderId);
      await updateDoc(docRef, {
        ...folderData,
        lastUpdated: serverTimestamp()
      });
      
      return {
        id: folderId,
        ...folderData
      };
    } catch (error) {
      console.error('Error al actualizar carpeta:', error);
      throw error;
    }
  },

  // Eliminar una carpeta
  deleteFolder: async (folderId) => {
    try {
      const docRef = doc(db, 'folders', folderId);
      await deleteDoc(docRef);
      return true;
    } catch (error) {
      console.error('Error al eliminar carpeta:', error);
      throw error;
    }
  },

  // Actualizar contador de documentos en una carpeta
  updateDocumentCount: async (folderId, count) => {
    try {
      const docRef = doc(db, 'folders', folderId);
      await updateDoc(docRef, {
        documentCount: count,
        lastUpdated: serverTimestamp()
      });
    } catch (error) {
      console.error('Error al actualizar contador de documentos:', error);
      throw error;
    }
  }
};

export default foldersService;
